import { useState } from 'react';
import { useEventListener } from 'src/core/hooks/useEventListener';
export default function useSelectedItems() {
    const [selectedItems, setSelectedItems] = useState({
        pages: [],
        modules: [],
        total: 0,
        publishedCount: 0,
        unpublishedCount: 0
    });
    const handler = (event) => {
        setSelectedItems(event.detail);
    };
    useEventListener('modulelistselecteditemschange', handler);
    return {
        pages: selectedItems.pages,
        modules: selectedItems.modules,
        total: selectedItems.total,
        hasPublished: selectedItems.publishedCount > 0 || selectedItems.modules.length > 0,
        hasUnpublished: selectedItems.unpublishedCount > 0 || selectedItems.modules.length > 0
    };
}
